<div>
  <div [class]="presentation.containerClass">
    @if (presentation.logoPath) {
      <img [src]="presentation.logoPath" [alt]="presentation.altText">
    }
  </div>
</div>
